import clsx from "clsx";
import type { ChangeEvent } from "react";

type DropDownOption = {
	value: string;
	option: string;
};

type DropDownFieldProps = {
	options: DropDownOption[];
	valueKey?: string;
	labelKey?: string;
	value: string;
	placeholder?: string;
	onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
	className?: string;
};

export const DropDownField = ({
	options,
	valueKey = "value",
	labelKey = "option",
	value: selectedValue,
	placeholder = "",
	onChange,
	className,
	...props
}: DropDownFieldProps) => {
	const isPlaceholderSelected = !selectedValue;

	return (
		<select
			value={selectedValue ?? ""}
			onChange={onChange}
			className={clsx(
				isPlaceholderSelected ? "cC-text-gray-400" : "cC-text-gray-900",
				className,
			)}
			{...props}
		>
			{placeholder && (
				<option value="" disabled>
					{placeholder}
				</option>
			)}
			{options?.map((option) => {
				const optionValue = option[valueKey as keyof DropDownOption];
				const optionLabel = option[labelKey as keyof DropDownOption];

				return (
					<option key={optionValue} value={optionValue} className="cC-text-black">
						{optionLabel}
					</option>
				);
			})}
		</select>
	);
};
